import { useAtom } from 'jotai'
import { monthlyCoursesAtom, monthlyCourseIdAtom } from '@!/atoms/paymentAtom'
import { PrimaryButton } from '@!/components/Button'

const MonthlySubmitButton = ({ handleSubmit, restore }) => {
  const [monthlyCourses] = useAtom(monthlyCoursesAtom)
  const [monthlyCourseId] = useAtom(monthlyCourseIdAtom)
  const course = monthlyCourses.find((course) => course.id === monthlyCourseId)
  const dataGtmSubscription = restore ? `re-registration` : `menu_${course?.amount}`

  return (
    <PrimaryButton fontSize="lg" onClick={handleSubmit} data-gtm-subscription={dataGtmSubscription}>
      登録する
    </PrimaryButton>
  )
}

export default MonthlySubmitButton
